import React from 'react';
import { configureChains, createClient, WagmiConfig } from 'wagmi';
import { bsc, mainnet } from '@wagmi/chains';
import { alchemyProvider } from 'wagmi/providers/alchemy';
import { jsonRpcProvider } from 'wagmi/providers/jsonRpc';
import { CoinbaseWalletConnector } from 'wagmi/connectors/coinbaseWallet';
import { MetaMaskConnector } from 'wagmi/connectors/metaMask';
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';

import {
  EthereumClient,
  modalConnectors,
  walletConnectProvider,
} from '@web3modal/ethereum';

import { Web3Modal } from '@web3modal/react';
import { useTheme } from '@mui/material';
import useResponsive from '../../hooks/useResponsive';
import { ABOVE_TIDIO_ZINDEX } from '../../utils/commonValues';

const WagmiProvier = ({ children }) => {
  const smDown = useResponsive('down', 'sm');
  const theme = useTheme();
  // const alchemyId = process.env.REACT_APP_ALCHEMY_KEY;
  // const { provider, chains } = configureChains(
  //   [bsc],
  //   [
  //     jsonRpcProvider({
  //       rpc: (chain) => {
  //         if (chain.id !== bsc.id) return null;
  //         return { http: chain.rpcUrls.default.http[0] };
  //       },
  //     }),
  //     alchemyProvider({ apiKey: alchemyId }),
  //   ]
  // );

  // const client = createClient({
  //   autoConnect: true,
  //   connectors: [
  //     new MetaMaskConnector({ chains }),
  //     new CoinbaseWalletConnector({
  //       chains,
  //       options: {
  //         appName: 'wagmi',
  //       },
  //     }),
  //     new WalletConnectConnector({
  //       chains,
  //       options: {
  //         qrcode: true,
  //         qrcodeModalOptions: {
  //           desktopLinks: [
  //             'ledger',
  //             'tokenary',
  //             'wallet',
  //             'wallet 3',
  //             'secuX',
  //             'ambire',
  //             'wallet3',
  //             'apolloX',
  //             'zerion',
  //             'sequence',
  //             'punkWallet',
  //             'kryptoGO',
  //             'nft',
  //             'riceWallet',
  //             'vision',
  //             'keyring',
  //           ],
  //           mobileLinks: [
  //             'trust',
  //             'rainbow',
  //             'metamask',
  //             'argent',
  //             'imtoken',
  //             'pillar',
  //           ],
  //         },
  //       },
  //     }),
  //   ],
  //   provider,
  //   // webSocketProvider,
  // });

  const chains = [bsc];

  // Wagmi client
  const { provider } = configureChains(chains, [
    walletConnectProvider({ projectId: '290d030bc7da32df378665d380e2787b' }),
  ]);
  const client = createClient({
    autoConnect: true,
    connectors: smDown
      ? modalConnectors({ appName: 'web3Modal', chains })
      : [
          new MetaMaskConnector({ chains }),
          new CoinbaseWalletConnector({
            chains,
            options: {
              appName: 'wagmi',
            },
          }),
          new WalletConnectConnector({
            chains,
            options: {
              qrcode: false,
            },
          }),
        ],
    provider,
  });

  // Web3Modal Ethereum Client
  const ethereumClient = new EthereumClient(client, chains);

  return (
    <>
      <WagmiConfig client={client}>{children}</WagmiConfig>
      <Web3Modal
        projectId="290d030bc7da32df378665d380e2787b"
        ethereumClient={ethereumClient}
        themeZIndex={999999999}
        mobileWallets={[
          {
            id: 'metaMask',
            name: 'Metamask',
            links: {
              native: 'metamask://',
              universal: `https://metamask.app.link/dapp/app.woj.finance`,
            },
          },
          {
            id: 'trust',
            name: 'Trust Wallet',
            links: {
              native: `trust://open_url?coin_id=20000714&url=https://app.woj.finance/`,
            },
          },
          {
            id: 'rainbow',
            name: 'Rainbow',
            links: { native: 'rainbow://', universal: 'https://rainbow.me' },
          },
          {
            id: 'zerion',
            name: 'Zerion',
            links: {
              native: 'zerion://',
              universal: 'https://wallet.zerion.io',
            },
          },
          {
            id: 'tokenary',
            name: 'Tokenary',
            links: { native: 'tokenary://', universal: 'https://tokenary.io' },
          },
        ]}
      />
    </>
  );
};

export default WagmiProvier;
